import {UserOutlined} from "@ant-design/icons";
import {Avatar, Checkbox, Space, List, Typography} from "antd";
const {Text} = Typography;
export const StaffListItem = ({person, selectedStaff, handleStaffSelection}) => (
    <List.Item>
        <Checkbox
            checked={selectedStaff.includes(person.id)}
            onChange={(e) => handleStaffSelection(person.id, e.target.checked)}
        >
            <Space>
                <Avatar size="small" icon={<UserOutlined/>}/>
                <div>
                    <div>{person.firstname} {person.lastname}</div>
                </div>
            </Space>
        </Checkbox>
    </List.Item>
);